import { apiGet, apiPost, apiDelete } from "./entityApiShared.js";

export type FmeaRecordDto = {
  readonly id: string;
  readonly complaintId: string;
  readonly complaintCode?: string | undefined;
  readonly complaintTitle?: string | undefined;
  readonly rcaId?: string | null | undefined;
  readonly rcaCode?: string | null | undefined;
  readonly fmeaDocNo: string;
  readonly fmeaType: string;
  readonly revision: string;
  readonly processOrItem: string;
  readonly failureMode: string;
  readonly potentialCause?: string | null | undefined;
  readonly severity: number;
  readonly occurrence: number;
  readonly detection: number;
  readonly rpn: number;
  readonly actionPriority: string;
  readonly status: string;
  readonly ownerUserId: string;
  readonly ownerName?: string | undefined;
  readonly targetDate?: string | null | undefined;
  readonly createdAt: string;
};

export type FmeaCreateRequest = {
  readonly complaintId: string;
  readonly rcaId?: string | null | undefined;
  readonly fmeaDocNo?: string | undefined;
  readonly fmeaType?: string | undefined;
  readonly revision?: string | undefined;
  readonly processOrItem: string;
  readonly failureMode: string;
  readonly potentialCause?: string | undefined;
  readonly severity: number;
  readonly occurrence: number;
  readonly detection: number;
  readonly actionPriority?: string | undefined;
  readonly status?: string | undefined;
  readonly ownerUserId?: string | undefined;
  readonly targetDate?: string | undefined;
};

export const fmeaApi = {
  async queue(signal?: AbortSignal): Promise<readonly FmeaRecordDto[]> {
    const res = await apiGet<readonly FmeaRecordDto[]>("/api/cmts/fmea/queue", { signal });
    return res || [];
  },

  async listForComplaint(complaintId: string, signal?: AbortSignal): Promise<readonly FmeaRecordDto[]> {
    const res = await apiGet<readonly FmeaRecordDto[]>(`/api/cmts/complaints/${complaintId}/fmea`, { signal });
    return res || [];
  },

  async create(payload: FmeaCreateRequest, signal?: AbortSignal): Promise<FmeaRecordDto> {
    return await apiPost<FmeaRecordDto>("/api/cmts/fmea", payload, { signal });
  },

  async delete(id: string, signal?: AbortSignal): Promise<boolean> {
    return await apiDelete<boolean>(`/api/cmts/fmea/${id}`, { signal });
  }
};
